// extracted by mini-css-extract-plugin
export default {"legend":"Legend__legend___kBPHw","line":"Legend__line___7uC0Y","axisLabel":"Legend__axisLabel___Kps3h"};